/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { MediaUiAPauseIcon16Light } from './MediaUiAPauseIcon16Light';
import { MediaUiAPauseIcon16Regular } from './MediaUiAPauseIcon16Regular';
import { MediaUiAPauseIcon16Solid } from './MediaUiAPauseIcon16Solid';
import { MediaUiAPauseIcon20Light } from './MediaUiAPauseIcon20Light';
import { MediaUiAPauseIcon20Regular } from './MediaUiAPauseIcon20Regular';
import { MediaUiAPauseIcon20Solid } from './MediaUiAPauseIcon20Solid';
import { MediaUiAPauseIcon24Regular } from './MediaUiAPauseIcon24Regular';
import { MediaUiAPauseIcon24Solid } from './MediaUiAPauseIcon24Solid';
import { MediaUiAPauseIcon32Regular } from './MediaUiAPauseIcon32Regular';
import { MediaUiAPauseIcon64Regular } from './MediaUiAPauseIcon64Regular';
var sizes = {
    16: {
        light: MediaUiAPauseIcon16Light,
        regular: MediaUiAPauseIcon16Regular,
        solid: MediaUiAPauseIcon16Solid,
    },
    20: {
        light: MediaUiAPauseIcon20Light,
        regular: MediaUiAPauseIcon20Regular,
        solid: MediaUiAPauseIcon20Solid,
    },
    24: {
        regular: MediaUiAPauseIcon24Regular,
        solid: MediaUiAPauseIcon24Solid,
    },
    32: {
        regular: MediaUiAPauseIcon32Regular,
    },
    64: {
        regular: MediaUiAPauseIcon64Regular,
    },
};
export var MediaUiAPauseIcon = forwardRef('MediaUiAPauseIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
